const checkErrorMessage = (err) => {
  let errorDetails = {
    message: false,
    params: false,
    titles: false,
    status: 406,
    errorCode: null,
  };
  if (err?.response?.data) {
    const data = err.response.data;
    errorDetails.errorCode = data.errorCode || null;
    if (data.data?.titles)
      errorDetails.titles = data.data.titles.join(" - ");
    if (data.data?.params) errorDetails.params = data.data.params;
    if (data.message) errorDetails.message = data.message;
  } else if (err?.response) {
    errorDetails.message = "خطا در ارتباط با سرور";
  } else {
    errorDetails.message = "اتصال اینترنت خود را بررسی کنید";
  }
  if (err?.response?.status) {
    errorDetails.status = err.response.status;
  }
  return errorDetails;
};

const checkResponseData = (response) => {
  let responseDetails = {
    success: false,
    message: false,
    data: false,
    moreInfo: {},
  };
  if (response?.data?.success) {
    if (response.data.message)
      responseDetails.message = response.data.message;
    if (response.data.data) responseDetails.data = response.data.data;
    if (response.data.token) responseDetails.token = response.data.token;
    if (response.data.moreInfo)
      responseDetails.moreInfo = response.data.moreInfo;
    responseDetails.success = true;
  }
  return responseDetails;
};

const filterItems = (obj) => {
  for (const property in obj) {
    if (typeof obj[property] === "boolean") continue;
    if (!obj[property]) delete obj[property];
  }
  return obj;
};

export { checkErrorMessage, checkResponseData, filterItems };
